

































import {Component, Vue} from 'vue-property-decorator'
import Overlay from '@/components/common/Overlay.vue'
import {Getter, Mutation, Action} from 'vuex-class'
import {ItemType} from '@/store/types'
import InventoryItem from '@/components/inventory/InventoryItem.vue'
import InventoryAddedItem from '@/components/inventory/InventoryAddedItem.vue'
import AppHeader from '@/components/common/AppHeader.vue'
import Fuse from 'fuse.js'

@Component({
  components: {
    Overlay,
    InventoryItem,
    InventoryAddedItem,
    AppHeader,
  },
})
export default class InventoryItemsOverlay extends Vue {
  @Getter('itemTypes') public itemTypes!: ItemType[]
  @Getter('showInventoryAddedItem') public showInventoryAddedItem!: boolean
  @Mutation('setInventoryItemListOverlay') public setInventoryItemListOverlay!: any
  @Action('focusSearch') public focusSearch!: any
  @Action('groupLoading') public groupLoading: any
  @Action('getItemTypes') public getItemTypes!: any

  public searchText: string = ''
  public loaded = false
  public $refs: any

  public get filteredItems() {
    if (this.searchText.length) {
      const fuse = new Fuse(this.itemTypes, {distance: 100, threshold: 0.2, keys: ['name']})
      const items = fuse.search(this.searchText)
      if (items.length) {
        return items
      } else {
        return [
          {name: this.searchText, custom: true, id: 1, volume: 1},
        ]
      }
    } else {
      return this.itemTypes
    }
  }

  public selectInput() {
    const activeSearch = document.activeElement as HTMLInputElement
    setTimeout(() => {
      activeSearch.selectionStart = activeSearch.selectionEnd = 99999
    }, 1)
  }

  public clearSearch() {
    this.searchText = ''
    this.$refs.search.focus()
  }

  public back() {
    this.setInventoryItemListOverlay(false)
    this.groupLoading([
      this.getItemTypes(),
    ]).then((value: any[]) => {
      this.loaded = true
    })
  }
}
